export default __webpack_public_path__ + "static/media/4.728165d0.png";